const base = "cui-modal-sgfx";
const content = "cui-modal-content-ilu0";
const immersive = "cui-modal-immersive-mros";
const classes = {
  base,
  content,
  immersive
};
export {
  base,
  content,
  classes as default,
  immersive
};
